module.exports = require('./components/Modal');




//////////////////
// WEBPACK FOOTER
// ../node_modules/react-modal/lib/index.js
// module id = 236
// module chunks = 0